import {
	CreateMedia,
	GetMedia,
	GetMediaPagesForMeeting,
	SaveMediaItem,
	SaveMediaPage,
} from '../../connection/media';
import { Action, AsyncAction } from '../types/types';
import {
	MediaItem,
	MediaUpdateEventInfo,
	PageDeleted,
	PagedMediaItemExisting,
	PagedMediaItemNew,
	PresentedMediaItem,
	VideoState,
} from '../reducers/media';

export const CREATE_MEDIA = 'CREATE_MEDIA';
export function createMedia(token: string, media: MediaItem): AsyncAction {
	return {
		type: CREATE_MEDIA,
		promise: CreateMedia(token, media),
	};
}

export const UPDATE_MEDIA = 'UPDATE_MEDIA';
export function updateMedia(media: MediaItem[]) {
	return {
		type: UPDATE_MEDIA,
		payload: media,
	};
}

export const UPDATE_SINGLE_MEDIA = 'UPDATE_SINGLE_MEDIA';
export function updateSingleMedia(media: MediaItem) {
	return {
		type: UPDATE_SINGLE_MEDIA,
		payload: media,
	};
}

export const GET_MEDIA = 'GET_MEDIA';
export function getMedia(token: string, meeting: number): AsyncAction {
	return {
		type: GET_MEDIA,
		promise: GetMedia(token, meeting),
	};
}

export const SET_CURRENTLY_UPLOADING_MEDIA = 'SET_CURRENTLY_UPLOADING_MEDIA';
export function setCurrentlyUploadingMedia(media: MediaItem | undefined): Action {
	return {
		type: SET_CURRENTLY_UPLOADING_MEDIA,
		payload: media,
	};
}

export const SAVE_MEDIA_ITEM = 'SAVE_MEDIA_ITEM';
export function saveMediaItem(
	token: string,
	mediaItem: MediaItem,
	pageDeleted: PageDeleted | undefined,
): AsyncAction {
	return {
		type: SAVE_MEDIA_ITEM,
		promise: SaveMediaItem(token, mediaItem, pageDeleted),
	};
}

export const SET_SELECTED_MEDIA = 'SET_SELECTED_MEDIA';
export function setSelectedMedia(mediaItem: MediaItem | undefined): Action {
	return {
		type: SET_SELECTED_MEDIA,
		payload: [mediaItem],
	};
}

export const SET_MEDIA_MODAL_OPEN = 'SET_MEDIA_MODAL_OPEN';
export function setMediaModalOpen(open: boolean, mediaItem: MediaItem | undefined): Action {
	return {
		type: SET_MEDIA_MODAL_OPEN,
		payload: [open, mediaItem],
	};
}

export const SET_MEDIA_SELECTED_PAGE = 'SET_MEDIA_SELECTED_PAGE';
export function setSelectedPage(page: number): Action {
	return {
		type: SET_MEDIA_SELECTED_PAGE,
		payload: page,
	};
}

export const SET_MEDIA_SLIDE_ANIMATIONS = 'SET_MEDIA_SLIDE_ANIMATIONS';
export function setSlideAnimations(type: string): Action {
	return {
		type: SET_MEDIA_SLIDE_ANIMATIONS,
		payload: type,
	};
}

export const SET_MEDIA_SLIDE_DIRECTION = 'SET_MEDIA_SLIDE_DIRECTION';
export function setSlideDirection(direction: string): Action {
	return {
		type: SET_MEDIA_SLIDE_DIRECTION,
		payload: direction,
	};
}

export const SET_SHARED_WITH = 'SET_SHARED_WITH';
export function setSharedWith(sharedWith: string) {
	return {
		type: SET_SHARED_WITH,
		payload: sharedWith,
	};
}

export const SET_SHARED_MEDIA_PAGES_VIEW_ON = 'SET_SHARED_MEDIA_PAGES_VIEW_ON';
export function setSharedMediaPagesViewOn(on: boolean) {
	return {
		type: SET_SHARED_MEDIA_PAGES_VIEW_ON,
		payload: on,
	};
}

export const SET_ID_OF_CURRENTLY_UPLOADING_MEDIA = 'SET_ID_OF_CURRENTLY_UPLOADING_MEDIA';
export function setIdOfCurrentlyUploadingMedia(id: string) {
	return {
		type: SET_ID_OF_CURRENTLY_UPLOADING_MEDIA,
		payload: id,
	};
}

export const DELETE_MEDIA_ITEM = 'DELETE_MEDIA_ITEM';
export function deleteMediaItem(id: number) {
	return {
		type: DELETE_MEDIA_ITEM,
		payload: id,
	};
}

export const SET_PRESENTED_MEDIA = 'SET_PRESENTED_MEDIA';
export function setPresentedMedia(presentedMedia: PresentedMediaItem[]) {
	return {
		type: SET_PRESENTED_MEDIA,
		payload: presentedMedia,
	};
}

export const SET_CURRENTLY_UPLOADING_IN_MODAL = 'SET_CURRENTLY_UPLOADING_IN_MODAL';
export function setCurrentlyUploadingInModal(idArray: number[]): Action {
	return {
		type: SET_CURRENTLY_UPLOADING_IN_MODAL,
		payload: idArray,
	};
}

export const SYNC_MEDIA_REDUCER_STATE = 'SYNC_MEDIA_REDUCER_STATE';
export function syncMediaReducerState(state: any): Action {
	return {
		type: SYNC_MEDIA_REDUCER_STATE,
		payload: state,
	};
}

interface SetPresentedMediaVideoStatePayload {
	mediaId: number,
	videoState: VideoState,
	doEmitChanges: boolean
}
export const SET_PRESENTED_MEDIA_VIDEOSTATE = 'SET_PRESENTED_MEDIA_VIDEOSTATE';
export function setPresentedMediaVideoState(state: SetPresentedMediaVideoStatePayload): Action {
	return {
		type: SET_PRESENTED_MEDIA_VIDEOSTATE,
		payload: state,
	};
}

export const SET_PRESENTED_MEDIA_PAGE = 'SET_PRESENTED_MEDIA_PAGE';
export function setPresentedMediaPage(
	mediaId: number,
	currentPage: number,
	videoState?: VideoState,
): Action {
	return {
		type: SET_PRESENTED_MEDIA_PAGE,
		payload: { mediaId, currentPage, videoState },
	};
}

export const ADD_PRESENTED_MEDIA = 'ADD_PRESENTED_MEDIA';
export function addPresentedMedia(media: PresentedMediaItem): Action {
	return {
		type: ADD_PRESENTED_MEDIA,
		payload: media,
	};
}

export const REMOVE_PRESENTED_MEDIA = 'REMOVE_PRESENTED_MEDIA';
export function removePresentedMedia(mediaId: number): Action {
	return {
		type: REMOVE_PRESENTED_MEDIA,
		payload: mediaId,
	};
}

export const SET_NOTIFY_ON_UPDATE = 'SET_NOTIFY_ON_UPDATE';
export function setNotifyOnUpdate(notify: boolean): Action {
	return {
		type: SET_NOTIFY_ON_UPDATE,
		payload: notify,
	};
}

export const SET_MEDIA_UPDATE_EVENT_INFO = 'SET_MEDIA_UPDATE_EVENT_INFO';
export function setMediaUpdateEventInfo(mediaUpdateEventInfo: MediaUpdateEventInfo): Action {
	return {
		type: SET_MEDIA_UPDATE_EVENT_INFO,
		payload: mediaUpdateEventInfo,
	};
}

export const GET_MEDIA_PAGES_FOR_MEETING = 'GET_MEDIA_PAGES_FOR_MEETING';
export function getMediaPagesForMeeting(
	token: string,
	meetingNumber: number,
): AsyncAction {
	return {
		type: GET_MEDIA_PAGES_FOR_MEETING,
		promise: GetMediaPagesForMeeting(
			token,
			meetingNumber,
		),
	};
}

export const SAVE_MEDIA_PAGE = 'SAVE_MEDIA_PAGE';
export function saveMediaPage(
	token: string,
	meetingNumber: number,
	pagedMediaItem: PagedMediaItemNew | PagedMediaItemExisting,
	from: string,
): AsyncAction {
	return {
		type: SAVE_MEDIA_PAGE,
		promise: SaveMediaPage(
			token,
			meetingNumber,
			pagedMediaItem,
			from,
		),
	};
}

export const UPDATE_MEDIA_PAGE = 'UPDATE_MEDIA_PAGE';
export function updateMediaPage(
	pagedMediaItem: PagedMediaItemExisting,
): Action {
	return {
		type: UPDATE_MEDIA_PAGE,
		payload: pagedMediaItem,
	};
}

export const DELETE_MEDIA_PAGES = 'DELETE_MEDIA_PAGES';
export function deleteMediaPages(
	idsToDelete: number[],
): Action {
	return {
		type: DELETE_MEDIA_PAGES,
		payload: idsToDelete,
	};
}

export const SET_SHOWBUILDER_MEDIA = 'SET_SHOWBUILDER_MEDIA';
export function setShowbuilderMedia(
	showbuilderMedia: PresentedMediaItem[],
): Action {
	return {
		type: SET_SHOWBUILDER_MEDIA,
		payload: showbuilderMedia,
	};
}
